export interface SiteItem {
  id: string;
  name: string;
  url: string;
  description: string;
  categorySlug: string;
  tags: string[];
  rating: number;
  isHot: boolean;
  isNew: boolean;
  addedDate: string;
}

export const sites: SiteItem[] = [
  // 视频平台
  {
    id: "site-001",
    name: "樱花视频",
    url: "https://example.com",
    description: "海量高清视频资源，支持在线播放与下载，每日更新海量内容，流畅观影体验",
    categorySlug: "video",
    tags: ["高清", "在线播放", "每日更新"],
    rating: 4.8,
    isHot: true,
    isNew: false,
    addedDate: "2025-06-15",
  },
  {
    id: "site-002",
    name: "极速影院",
    url: "https://example.com",
    description: "极速加载，无需等待，海量片源覆盖全球热门内容，支持多线路切换",
    categorySlug: "video",
    tags: ["极速加载", "多线路", "全球片源"],
    rating: 4.6,
    isHot: true,
    isNew: false,
    addedDate: "2025-05-20",
  },
  {
    id: "site-003",
    name: "星辰影视",
    url: "https://example.com",
    description: "4K超高清画质，杜比音效，沉浸式观影体验，分类细致便于查找",
    categorySlug: "video",
    tags: ["4K高清", "杜比音效", "分类细致"],
    rating: 4.7,
    isHot: false,
    isNew: true,
    addedDate: "2026-07-28",
  },
  {
    id: "site-004",
    name: "蓝海视频站",
    url: "https://example.com",
    description: "全新上线的视频平台，界面简洁美观，内容丰富多样，支持多端同步观看",
    categorySlug: "video",
    tags: ["界面美观", "多端同步", "内容丰富"],
    rating: 4.5,
    isHot: false,
    isNew: true,
    addedDate: "2026-08-01",
  },
  {
    id: "site-005",
    name: "极光资源站",
    url: "https://example.com",
    description: "老牌视频站点，资源积累深厚，分类齐全，更新稳定，值得信赖的选择",
    categorySlug: "video",
    tags: ["老牌站点", "资源丰富", "更新稳定"],
    rating: 4.4,
    isHot: true,
    isNew: false,
    addedDate: "2024-11-10",
  },
  {
    id: "site-006",
    name: "星空TV",
    url: "https://example.com",
    description: "全天候不间断更新，热门内容第一时间上线，支持弹幕互动观看",
    categorySlug: "video",
    tags: ["全天更新", "弹幕互动", "热门首发"],
    rating: 4.3,
    isHot: false,
    isNew: false,
    addedDate: "2025-08-22",
  },
  // 直播平台
  {
    id: "site-007",
    name: "热力直播",
    url: "https://example.com",
    description: "真人实时互动直播，高清画质低延迟，多样化直播间满足不同需求",
    categorySlug: "live",
    tags: ["实时互动", "高清直播", "低延迟"],
    rating: 4.9,
    isHot: true,
    isNew: false,
    addedDate: "2025-04-18",
  },
  {
    id: "site-008",
    name: "蜜桃直播",
    url: "https://example.com",
    description: "全新直播体验，智能推荐系统精准匹配喜好，互动玩法丰富有趣",
    categorySlug: "live",
    tags: ["智能推荐", "互动玩法", "精准匹配"],
    rating: 4.7,
    isHot: true,
    isNew: true,
    addedDate: "2026-06-30",
  },
  {
    id: "site-009",
    name: "星秀直播间",
    url: "https://example.com",
    description: "美女主播云集，才艺展示与互动交流，7x24小时精彩不断",
    categorySlug: "live",
    tags: ["美女主播", "才艺展示", "全天候"],
    rating: 4.5,
    isHot: false,
    isNew: false,
    addedDate: "2025-09-12",
  },
  {
    id: "site-010",
    name: "乐播Live",
    url: "https://example.com",
    description: "沉浸式直播体验，支持VR观看模式，多视角切换功能让体验更丰富",
    categorySlug: "live",
    tags: ["VR直播", "多视角", "沉浸体验"],
    rating: 4.6,
    isHot: false,
    isNew: true,
    addedDate: "2026-07-15",
  },
  // 图片图库
  {
    id: "site-011",
    name: "美图集",
    url: "https://example.com",
    description: "海量高清美图资源，每日更新精选套图，支持批量下载和一键收藏",
    categorySlug: "image",
    tags: ["海量图库", "每日更新", "批量下载"],
    rating: 4.8,
    isHot: true,
    isNew: false,
    addedDate: "2025-03-25",
  },
  {
    id: "site-012",
    name: "画廊世界",
    url: "https://example.com",
    description: "专业摄影级图片资源，分类详尽标签精准，AI智能推荐感兴趣的内容",
    categorySlug: "image",
    tags: ["专业摄影", "AI推荐", "标签精准"],
    rating: 4.6,
    isHot: false,
    isNew: false,
    addedDate: "2025-07-08",
  },
  {
    id: "site-013",
    name: "像素艺廊",
    url: "https://example.com",
    description: "全新上线的图片站点，界面简洁美观，支持多种格式高清原图下载",
    categorySlug: "image",
    tags: ["界面简洁", "原图下载", "多格式"],
    rating: 4.4,
    isHot: false,
    isNew: true,
    addedDate: "2026-08-05",
  },
  {
    id: "site-014",
    name: "图享空间",
    url: "https://example.com",
    description: "社区化图片分享平台，用户可上传分享交流，建立个人收藏专辑",
    categorySlug: "image",
    tags: ["社区分享", "个人专辑", "互动交流"],
    rating: 4.3,
    isHot: false,
    isNew: false,
    addedDate: "2025-12-01",
  },
  // 小说文学
  {
    id: "site-015",
    name: "书香阁",
    url: "https://example.com",
    description: "海量小说资源库，涵盖各类题材，支持在线阅读和离线下载",
    categorySlug: "novel",
    tags: ["海量书库", "在线阅读", "离线下载"],
    rating: 4.7,
    isHot: true,
    isNew: false,
    addedDate: "2025-02-14",
  },
  {
    id: "site-016",
    name: "悦读文学城",
    url: "https://example.com",
    description: "原创文学社区，汇聚优秀作者作品，读者互动评论氛围浓厚",
    categorySlug: "novel",
    tags: ["原创文学", "作者社区", "读者互动"],
    rating: 4.5,
    isHot: false,
    isNew: false,
    addedDate: "2025-06-30",
  },
  {
    id: "site-017",
    name: "墨香书屋",
    url: "https://example.com",
    description: "全新文学阅读平台，智能排版舒适阅读，支持听书模式解放双眼",
    categorySlug: "novel",
    tags: ["智能排版", "听书模式", "舒适阅读"],
    rating: 4.6,
    isHot: false,
    isNew: true,
    addedDate: "2026-07-20",
  },
  // 动漫漫画
  {
    id: "site-018",
    name: "漫趣社",
    url: "https://example.com",
    description: "日韩欧美动漫漫画资源大全，高清画质流畅阅读，更新及时追番必备",
    categorySlug: "comic",
    tags: ["日韩欧美", "高清画质", "更新及时"],
    rating: 4.8,
    isHot: true,
    isNew: false,
    addedDate: "2025-01-20",
  },
  {
    id: "site-019",
    name: "二次元空间",
    url: "https://example.com",
    description: "专注二次元内容，漫画动画轻小说一站式覆盖，社区氛围活跃",
    categorySlug: "comic",
    tags: ["二次元", "一站式", "社区活跃"],
    rating: 4.5,
    isHot: false,
    isNew: false,
    addedDate: "2025-04-15",
  },
  {
    id: "site-020",
    name: "绘梦工坊",
    url: "https://example.com",
    description: "全新上线的漫画平台，支持竖屏滚动阅读模式，智能预加载流畅体验",
    categorySlug: "comic",
    tags: ["竖屏阅读", "智能预加载", "流畅体验"],
    rating: 4.4,
    isHot: false,
    isNew: true,
    addedDate: "2026-08-02",
  },
  // 社区论坛
  {
    id: "site-021",
    name: "知心社区",
    url: "https://example.com",
    description: "大型交流论坛，板块分类清晰，用户活跃度高，每日发帖量过万",
    categorySlug: "forum",
    tags: ["大型论坛", "板块清晰", "高活跃度"],
    rating: 4.6,
    isHot: true,
    isNew: false,
    addedDate: "2024-08-30",
  },
  {
    id: "site-022",
    name: "夜话茶馆",
    url: "https://example.com",
    description: "轻松自在的交流空间，匿名发帖保护隐私，话题广泛讨论自由",
    categorySlug: "forum",
    tags: ["匿名发帖", "隐私保护", "话题广泛"],
    rating: 4.4,
    isHot: false,
    isNew: false,
    addedDate: "2025-10-05",
  },
  // 实用工具
  {
    id: "site-023",
    name: "万能工具箱",
    url: "https://example.com",
    description: "集合多种实用功能，视频下载、格式转换、资源搜索、云存储一应俱全",
    categorySlug: "tool",
    tags: ["多功能", "视频下载", "格式转换"],
    rating: 4.7,
    isHot: true,
    isNew: false,
    addedDate: "2025-05-18",
  },
  {
    id: "site-024",
    name: "极速下载器",
    url: "https://example.com",
    description: "专业的资源下载工具，支持多线程加速和断点续传，下载速度飞快",
    categorySlug: "tool",
    tags: ["多线程", "断点续传", "极速下载"],
    rating: 4.5,
    isHot: false,
    isNew: true,
    addedDate: "2026-07-25",
  },
  // 游戏娱乐
  {
    id: "site-025",
    name: "游乐园",
    url: "https://example.com",
    description: "成人向游戏资源平台，涵盖各类游戏类型，支持在线试玩和完整下载",
    categorySlug: "game",
    tags: ["游戏资源", "在线试玩", "完整下载"],
    rating: 4.8,
    isHot: true,
    isNew: false,
    addedDate: "2025-03-10",
  },
  {
    id: "site-026",
    name: "新游速递站",
    url: "https://example.com",
    description: "第一时间获取最新游戏资讯和资源，评测客观专业，下载安全可靠",
    categorySlug: "game",
    tags: ["最新游戏", "专业评测", "安全下载"],
    rating: 4.6,
    isHot: false,
    isNew: true,
    addedDate: "2026-08-08",
  },
];

export const getSitesByCategory = (categorySlug: string) => {
  return sites.filter((s) => s.categorySlug === categorySlug);
};

export const getHotSites = (limit: number = 12) => {
  return sites.filter((s) => s.isHot).slice(0, limit);
};

export const getNewSites = (limit: number = 12) => {
  return [...sites]
    .sort((a, b) => new Date(b.addedDate).getTime() - new Date(a.addedDate).getTime())
    .slice(0, limit);
};

export const getSiteById = (id: string) => {
  return sites.find((s) => s.id === id) || null;
};